import React from 'react';
import * as MyCells from '../../../utils/Cells';
import ActionMenu from '../../common/action/ActionMenu';
import StateMultiSelectColumnFilter, { StateMultiSelectFilterFn } from '../../common/filters/StateMultiSelectColumnFilter';
import TextColumnFilter from '../../common/filters/TextColumnFilter';
import DateRangeColumnFilter, { DateRangeColumnFilterFn } from '../../common/filters/DateRangeColumnFilter';

export const columns = (refresh) => {
    return [
        {
            Header: 'Partner típus',
            accessor: 'partnerTypeLabel',
            id: 'partnerTypeLabel',
            show: true,
            className: 'partnerTypeColumn',
            Filter: StateMultiSelectColumnFilter,
            filter: StateMultiSelectFilterFn,
        },
        {
            Header: 'Partner',
            accessor: 'partnerName',
            id: 'partnerName',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Bankszámlaszám',
            accessor: 'bankAccountNumber',
            id: 'bankAccountNumber',
            show: true,
            className: 'bankAccountNumberColumn',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Érvényesség kezdete',
            accessor: 'validFrom',
            id: 'validFrom',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Érvényesség vége',
            accessor: 'validUntil',
            id: 'validUntil',
            className: 'dateColumn',
            show: true,
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: () => null, // No header
            Cell: value => <ActionMenu row={value.row.original} tabletype={'bankaccountnumber'} refresh={refresh} />,
            id: 'menu',
            show: true,
            headerClassName: 'actions',
            className: 'actions',
        },
    ]
}